module.exports = __webpack_public_path__ + "media/images/logo_galaxus-15d67e2982368d3bdff0220087e510c5.png";